import styled from 'styled-components'

export const DetailsSubItemContainer = styled.div`
  &:not(nth-of-type(:last-child)) {
    margin-bottom: 3rem;
  }

  h3 {
    font-size: 36px;
    color: var(--dark);
    margin-right: 1.5rem;
  }

  img,
  video {
    max-width: 100%;
  }

  img {
    width: 100%;
    height: auto;
  }

  @media only screen and (max-width: 500px) {
    h3 {
      font-size: 24px;
    }
  }
`
